import { alpha, darken, Fab, lighten, Tooltip, useTheme, Zoom } from "@mui/material";

const OmniGraphFab = props => {
  const { tooltipTitle = "", placement = "top", selected = false, color = "secondary" } = props;
  const theme = useTheme();

  return (
    <Tooltip
      title={tooltipTitle}
      placement={placement}
      disableInteractive
      enterDelay={500}
      enterNextDelay={500}
      TransitionComponent={Zoom}
      TransitionProps={{ timeout: 200, easing: "ease-in-out" }}
    >
      <Fab
        aria-label="edit"
        size="small"
        sx={[
          {
            boxShadow: theme.shadows[3],
            width: "36px",
            height: "36px",
            marginTop: "4px",
            marginLeft: theme.spacing(1),
            backgroundColor: "transparent",
            border: `1px solid ${theme.palette[color].main}`,
            zIndex: 1,
            color: theme.palette[color].main,
            transform: "none",
            transition: "all 0.05s ease-out",
            transitionOrigin: "center",
            "& .MuiSvgIcon-root": {
              fill: theme.palette[color].main,
            },
            "&:hover": {
              color: theme.palette[color].main,
              background: alpha(lighten(theme.palette[color].main, 0.75), 0.6),
              borderColor: theme.palette[color].main,
              transform: "scale(1.075)",
              "& > *": {
                fill: theme.palette[color].main,
              },
            },
            "&:active": {
              color: `${darken(theme.palette[color].main, 0.1)}`,
              borderColor: `${darken(theme.palette[color].main, 0.1)}`,
              boxShadow: `inset 0px 0px 3px ${alpha(
                lighten(theme.palette[color].main, 0.35),
                0.6,
              )}`,
              background: alpha(lighten(theme.palette[color].main, 0.65), 0.6),
              transform: "scale(0.925)",
              transition: "none",
            },
          },
          selected && {
            color: `${darken(theme.palette[color].main, 0.2)}`,
            borderColor: `${darken(theme.palette[color].main, 0.1)}`,
            boxShadow: `inset 0px 3px 1px -2px rgba(0,0,0,0.2), inset 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)`,
            background: alpha(lighten(theme.palette[color].main, 0.65), 0.4),
            transform: "none",
            transition: "all 0.05s ease-out",
            "& .MuiSvgIcon-root": {
              fill: `${darken(theme.palette[color].main, 0.2)}`,
            },
            "&:hover, :active": {
              color: `${darken(theme.palette[color].main, 0.2)}`,
              borderColor: `${darken(theme.palette[color].main, 0.1)}`,
              boxShadow: `inset 0px 3px 1px -2px rgba(0,0,0,0.2), inset 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)`,
              background: alpha(lighten(theme.palette[color].main, 0.65), 0.4),
              transform: "none",
              "& > *": {
                fill: `${darken(theme.palette[color].main, 0.2)}`,
                transform: "scale(1)",
                transition: "none",
              },
            },
            "&:active": {
              color: `${darken(theme.palette[color].main, 0.2)}`,
              borderColor: `${darken(theme.palette[color].main, 0.1)}`,
              boxShadow: `inset 0px 0px 3px ${alpha(
                lighten(theme.palette[color].main, 0.35),
                0.6,
              )}`,
              background: alpha(lighten(theme.palette[color].main, 0.65), 0.6),
              "& > *": {
                fill: `${darken(theme.palette[color].main, 0.2)}`,
                transform: "scale(1)",
                transition: "none",
              },
            },
          },
        ]}
        {...props}
      />
    </Tooltip>
  );
};

export default OmniGraphFab;
